import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import * as moment from 'moment';
import { SelectItem } from 'primeng/components/common/api';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { CalendarTranslate } from '../../../../models/calendarTranslate.model';
import { CustomerBasicInfo } from '../../../../models/customer.model';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { CountryService } from '../../../../services/country/country.service';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';
import { EducationService } from '../../../../services/education/education.service';
import { EmploymentService } from '../../../../services/employment/employment.service';
import { LoyaltyParamsService } from '../../../../services/loyalty/params.service';
import { ProvinceService } from '../../../../services/province/province.service';
import { SourceSystemService } from '../../../../services/source-system/source-system.service';
import { StateService } from '../../../../services/state/state.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { ToponymService } from '../../../../services/toponym/toponym.service';
import { AuthService } from '../../../../services/user/auth.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';


@Component({
  selector: 'app-customer-basic',
  templateUrl: './basic.component.html',
  providers: [],
})
export class CustomerDetailBasicComponent implements OnInit {

  @Input() customerId: string;

  @Output() basicInfoLoaded = new EventEmitter();
  @Output() dirtyFormData = new EventEmitter();

  validationData = null;
  editMode: boolean;
  canEditCustomerCode: boolean;
  provinces: SelectItem[] = [];
  countries: Array<any> = [];
  toponyms: SelectItem[] = [];
  states: Array<any> = [];
  source_systems: SelectItem[] = [];
  stores: SelectItem[] = [];
  formData: FormGroup;
  defaultSourceSystem = null;
  titlePage: 'customerDetail.addNew';
  employments: SelectItem[] = [];
  educations: SelectItem[] = [];
  today: Date = new Date();
  sessi: Array<{ value: string, label: string }>;
  calendarTranslate: CalendarTranslate;

  model = {
    country: null,
    state: null
  }

  private maxDate: Date = new Date();

  paramsTypeNewsletter: Array<{value: number, label: string}>;
  constructor(
    private fb: FormBuilder,
    private srvProvince: ProvinceService,
    private srvCountry: CountryService,
    private srvStates: StateService,
    private srvToponyms: ToponymService,
    private srvCustomer: CustomerInfoService,
    private srvValidation: FormValidationService,
    private srvParam: LoyaltyParamsService,
    private srvSourceSystem: SourceSystemService,
    private srvStore: StoreCommonService,
    private srvEducation: EducationService,
    private srvEmployment: EmploymentService,
    private srvCalendarTranslate: CalendarTranslateService,
    private translateService: TranslateService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    /*this.srvCustomer.getBasicInfo(this.customerId).subscribe((res) => {
      this.createForm(res);
    });*/
    let language = this.authService.sessionHelper.selectedLanguage;
    let paramGroupValue = 'FlgNewsletterEn';
    if(language == 'it')
      paramGroupValue  = 'FlgNewsletterIt';
    this.srvParam.list(null , null , [{key: 'param_group', value: paramGroupValue}]).subscribe(res => {
      this.paramsTypeNewsletter = [];
      for (const analyticType of res.data) {
        this.paramsTypeNewsletter.push({ value: Number(analyticType.param_code), label: analyticType.param_functional_code });
      }
      if(this.paramsTypeNewsletter.length == 0){
        this.paramsTypeNewsletter = [
          {value: 0, label: this.translateService.instant('customers.flgNewsletterNo')},
          {value: 1, label: this.translateService.instant('customers.flgNewsletterSi')}];
      }
    });
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);

    this.validationData = {ms_base_url: this.srvCustomer.getBaseUrl(), dto_name: 'CustomerBasicInfoDto', form: this.formData};
    this.provinces = [{value: null, label: ''}];
    this.countries = [{value: null, label: ''}];
    this.source_systems = [{value: null, label: ''}];
    this.stores = [{value: null, label: ''}];
    this.defaultSourceSystem = null;

    var self = this;

    this.srvCalendarTranslate.pCalendar.subscribe(res => {
      self.calendarTranslate = res;
    });



    let toponyms: Observable<any>;
    let basicInfo: Observable<CustomerBasicInfo>;
    let sourceSystems: Observable<any>;
    let defaultSourceParam: Observable<any>;
    let storeList: Observable<any>;

    sourceSystems = this.srvSourceSystem.getList();
    toponyms = this.srvToponyms.getAll();
    storeList = this.srvStore.getList(0, 1000);

    const employmentObs = this.srvEmployment.getList();
    const educationObs =  this.srvEducation.getList();

    // TODO: deve essere trasformata in una chiamata su paramKey
    defaultSourceParam = this.srvParam.list(null, null, [
      {key: 'param_group', value: 'CustomerDB'},
      {key: 'description', value: 'DefaultSourceSystem'}
    ]);

    this.editMode = (this.customerId !== undefined);

    if (this.editMode) {
      basicInfo = this.srvCustomer.getBasicInfo(this.customerId);
    } else {
      basicInfo = Observable.of(new CustomerBasicInfo);
    }

    Observable.zip(basicInfo, sourceSystems, toponyms, defaultSourceParam, storeList, employmentObs, educationObs)
      .subscribe(([resInfo, resSourceSystems, resToponyms, resDefaultSourceSystem, resStores, resEmployments, resEducations]) => {

        this.toponyms = []
        resToponyms.forEach(t => {
          this.toponyms.push({
            value: t.id,
            label: t.name
          })
        })

        this.employments = [{value: null, label: ''}];
        resEmployments.forEach(e => {
          this.employments.push({
            value: e.id,
            label: e.name
          })
        })

        this.educations = [{value: null, label: ''}];
        resEducations.forEach(e => {
          this.educations.push({
            value: e.id,
            label: e.description + ' (' + e.title + ')'
          })
        })

        this.sessi = [{value: '', label: ''}];


        for (const soruceSystem of resSourceSystems) {
          this.source_systems.push({
            value: soruceSystem.id,
            label: soruceSystem.name + ' (' + soruceSystem.description + ')'
          });
        }

        for (const store of resStores) {
          this.stores.push({
            value: store.id,
            label: store.code + ' - ' + store.description
          });
        }

        if (resDefaultSourceSystem.data.length > 0) {
          this.defaultSourceSystem = resDefaultSourceSystem.data[0].param_code
        }

        if (this.editMode) {

          if(resInfo && resInfo.country_id){
            let searchCountries = [
              {key: 'id',value: resInfo.country_id.toString()},
              {key: 'flg_state',value: '0'}
            ];
            this.srvCountry.list(null,null,searchCountries).subscribe(res=>{
              this.countries = [];
              if(res && res.data){
                this.countries = res.data;
                this.model.country = this.countries[0];
              }

              let searchStates = [
                {key: 'country_id',value: this.model.country.id},
                {key: 'flg_state',value: '0'}
              ];
              this.srvStates.list(null,null,searchStates).subscribe(res2=>{
                this.states = [];
                if(res2 && res2.data){
                  this.states = res2.data;
                }
                if(resInfo && resInfo.state_id){
                  let index = this.states.findIndex(x=>x.id == resInfo.state_id);
                  this.model.state = index > -1 ? this.states[index] : null;
                }

                this.srvProvince.getAll(resInfo.country_id, resInfo.state_id).subscribe(_provinces => {
                  this.provinces = [];
                  _provinces.forEach(p => {
                    this.provinces.push({
                      label: p.name,
                      value: p.id
                    })
                  })
                });

                this.basicInfoLoaded.emit(resInfo);
                this.createForm(resInfo);

              });
            });
          }
          else{
            this.basicInfoLoaded.emit(resInfo);
            this.createForm(resInfo);
          }

        }
        else{
          this.basicInfoLoaded.emit(resInfo);
          this.createForm(resInfo);
        }




      });

  }

  onChanges(): void {
    this.formData.valueChanges.subscribe(() => this.dirtyFormData.emit(this.formData.dirty));
  }

  createForm(data: CustomerBasicInfo) {

    const isNew = data == null;

    this.formData = this.fb.group({
      'id':                           this.editMode ? data.id : null,
      'source_system':                [ this.editMode ? data.source_system : this.defaultSourceSystem, Validators.required ],
      'customerCode':                 this.editMode ? data.customerCode : '',
      'preferred_store_id':           this.editMode ? data.preferred_store_id : '',
      'name':                         this.editMode ? data.name : '',
      'surname':                      this.editMode ? data.surname : '',
      'fiscal_code':                  [ this.editMode ? data.fiscal_code : '', KoncentroValidators.fiscalCode ],
      'group_number':                 [ this.editMode ? data.group_number : '', KoncentroValidators.integerNotNegative ],
      'address':                      this.editMode ? data.address : '',
      'address_2':                    this.editMode ? data.address_2 : '',
      'address_number':               this.editMode ? data.address_number : '',
      'province_id':                  new FormControl(this.editMode ? data.province_id : null),
      'city':                         this.editMode ? data.city : '',
      'zip_code':                     this.editMode ? data.zip_code : '',
      'country_id':                   new FormControl(this.editMode ? data.country_id : null),
      'state_id':                     new FormControl(this.editMode ? data.state_id : null),
      'toponym_id':                   new FormControl(this.editMode ? data.toponym_id : null),
      'phone_primary':                [ this.editMode ? data.phone_primary : '', KoncentroValidators.phone ],
      'phone_mobile':                 [ this.editMode ? data.phone_mobile : '', KoncentroValidators.phone ],
      'other_phone':                  [ this.editMode ? data.other_phone : '', KoncentroValidators.phone ],
      'email_primary':                [ this.editMode ? data.email_primary : '', KoncentroValidators.emailOrEmpty ],
      'email_secondary':              [ this.editMode ? data.email_secondary : '', KoncentroValidators.emailOrEmpty ],
      'flg_newsletter':               this.editMode ? data.flg_newsletter  : false,
      'flag_register_name':           this.editMode ? data.flag_register_name === '1' : false,
      'flag_general_communications':  this.editMode ? data.flag_general_communications === '1' : false,
      'flag_market_research':         this.editMode ? data.flag_market_research === '1' : false,
      'flag_privacy':                 [ this.editMode ? data.flag_privacy === '1' : false, Validators.requiredTrue ],
      'flag_profiling':               this.editMode ? data.flag_profiling === '1'  : false,
      'flag_marketing_activities':    this.editMode ? data.flag_marketing_activities === '1' : false,
      'flag_purchase_communications': this.editMode ? data.flag_purchase_communications === '1' : false,
      'flag_push_notifications':      this.editMode ? data.flag_push_notifications === '1' : false,
      birthday: (!isNew && data.birthday) ? [moment(data.birthday).toDate(), KoncentroValidators.dateNotAfter(this.maxDate)] : null,
      birth_city: (!isNew) ? data.birth_city : null,
      education: (!isNew) ? data.education : null,
      occupation: (!isNew) ? data.occupation : null,
      sex: (!isNew) ? data.sex : null
    });

    if (this.editMode) {
      this.formData.get('source_system').disable({onlySelf: true});
      this.formData.get('customerCode').disable({onlySelf: true});
    } else {
      this.sourceSystemChange()
    }

    this.onChanges();

  }

  customerCodeChange(code) {
    if (code.value !== '') {
      this.srvCustomer.getCustomerNotExists(this.formData.get('source_system').value, code.value).subscribe(resp => {

        if (resp === 'CustomerExists') {
          this.formData.get('customerCode').setErrors({ 'unique': false });
          this.formData.get('customerCode').markAsDirty({ onlySelf: true });
        } else {
          this.formData.get('customerCode').setErrors(null);
        }
      });
    } else {
      this.formData.get('customerCode').reset();
    }
  }

  sourceSystemChange() {
    this.canEditCustomerCode = +this.formData.get('source_system').value !== +this.defaultSourceSystem;

    if (this.canEditCustomerCode) {
      this.formData.get('customerCode').enable({onlySelf: true});
    } else {
      this.formData.get('customerCode').disable({onlySelf: true});
    }
  }

  public customSave(): Observable<any> {
    if (!this.formData.valid) {
      this.srvValidation.validateAllFormFields(this.formData);
      return Observable.of(false);
    }

    if (this.editMode) {
      return this.srvCustomer.putBasicInfo(this.customerId, this.formData.getRawValue());
    }

    return this.srvCustomer.post(this.formData.value);
  }

  /*** Gestione autocomplete Countries */
  filterCountrySingle(event){
    if(event){
      let search = [
        {key: 'name',value: event.query},
        {key: 'flg_state',value: '0'}
      ];
      this.srvCountry.list(null,null,search).subscribe(res=>{
        this.countries = [];
        if(res && res.data){
          this.countries = res.data;
        }
      })
    }
  }
  onSelectCountry(event){
    this.formData.get('country_id').setValue(event.id);
    this.model.state = null;
    this.formData.get('state_id').setValue(null);
    let search = [
      {key: 'country_id',value: event.id.toString()},
      {key: 'flg_state',value: '0'}
    ];
    this.srvStates.list(null,null,search).subscribe(res=>{
      this.states = [];
      if(res && res.data){
        this.states = res.data;
      }
    })
  }
  onClearCountry(){
    this.countries = [];
    this.states = [];
    this.provinces = [];
    this.formData.get('country_id').setValue(null);
    this.formData.get('state_id').setValue(null);
    this.formData.get('province_id').setValue(null);
    this.model.country = null;
    this.model.state = null;
  }
  /*** Gestione autocomplete States */
  filterStateSingle(event){
    if(event && this.model.country.id){
      let search = [
        {key: 'name',value: event.query},
        {key: 'country_id', value: this.model.country.id.toString()}
      ];
      this.srvStates.list(null,null,search).subscribe(res=>{
        this.states = [];
        if(res && res.data){
          this.states = res.data;
        }
      })
    }
  }
  onSelectState(event){
    this.formData.get('state_id').setValue(event.id);

    this.srvProvince.getAll(this.formData ? this.formData.get('country_id').value: null, this.formData ? this.formData.get('state_id').value: null).subscribe(_provinces => {
      this.provinces = [{label: '', value: null}];
      _provinces.forEach(p => {
        this.provinces.push({
          label: p.name,
          value: p.id
        })
      })
    })

  }
  onClearState(){
    this.states = [];
    this.model.state = null;
    this.provinces = [];
    this.formData.get('state_id').setValue(null);
    this.formData.get('province_id').setValue(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/basicinfo/basic.component.ts